import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {
    uploadBanner(formData) {
        return axios.post("/api/banner/upload/", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {

                if (response && response.data) {
                    Vue.prototype.$snotify.success(i18n.t('services.banner.uplode'));
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); })
    },

    
    getBanners (page, pageSize) {
        return axios.get('/api/banner/list',{ params: { page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeBanner (bannerId) {
        return axios.post('/api/banner/remove', {id : bannerId})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.banner.delete'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    savePosition (banner) {
        return axios.post('/api/banner/changePosition', banner)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.banner.edit'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}